import { useEffect, useCallback, MutableRefObject } from 'react'

export function useClickOutside(ref: MutableRefObject<HTMLElement | undefined | null>, callback: () => void): void {
    const handleClick = useCallback(
        e => {
            if (!ref.current || !ref.current.contains(e.target)) {
                callback()
            }
        },
        [callback, ref]
    )

    useEffect(() => {
        document.addEventListener('click', handleClick)

        return () => {
            document.removeEventListener('click', handleClick)
        }
    }, [handleClick])
}
